<div class="container p-4">
    <div class="row d-flex justify-content-center">
        <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
        <div class="col-12 text-center modal-title mb-4">{{'ACTIONS.COMPLETE' | translate}}</div>
    </div>

    <div class="ren-req-form">
        <div class="row">
            <app-dynamic-form [formName]="'stagingForm'" [formData]="formData!" [form]="formData!" [disabled]="false"
                [submitButton]="'ACTIONS.TO_COMPLETE' | translate" [customFunctions]="customFunctions"
                (formSubmit)="manualComplete($event)" (formChange)="onEvent('formChange', $event)"
                (formValidation)="onEvent('formValidation', $event)" #dynamicForm></app-dynamic-form>
        </div>
    </div>
</div>